import { render, staticRenderFns } from "./Karin-report-table.vue?vue&type=template&id=496dba8e&scoped=true"
import script from "./Karin-report-table.vue?vue&type=script&lang=js"
export * from "./Karin-report-table.vue?vue&type=script&lang=js"
import style0 from "./Karin-report-table.vue?vue&type=style&index=0&id=496dba8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496dba8e",
  null
  
)

export default component.exports